"use client";

import { useMemo, useState } from "react";
import AreaCodeRow from "@/components/AreaCodeRow";
import NoResults from "@/components/NoResults";
import PrintableButton from "@/components/PrintableButton";
import type { AreaCode } from "@/types/areaCode";

type AreaCodeTableProps = {
  records: AreaCode[];
};

export default function AreaCodeTable({ records }: AreaCodeTableProps) {
  const [query, setQuery] = useState("");
  const filtered = useMemo(() => {
    const normalized = query.trim();
    if (!normalized) {
      return records;
    }

    return records.filter((areaCode) => areaCode.code.includes(normalized.replace(/\D/g, "")));
  }, [query, records]);

  return (
    <section className="directory-section" aria-labelledby="by-number-title">
      <div className="directory-heading">
        <h2 id="by-number-title">By Number</h2>
        <PrintableButton />
      </div>
      <div className="print:hidden mb-4 max-w-sm">
        <label className="mb-2 block text-sm font-semibold text-ink" htmlFor="search-by-number">
          Search by Number
        </label>
        <input
          className="directory-input"
          id="search-by-number"
          inputMode="numeric"
          placeholder="212"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
        />
      </div>
      {filtered.length > 0 ? (
        <div className="directory-table-wrap">
          <table className="directory-table">
            <caption className="sr-only">Area codes listed by number</caption>
            <thead>
              <tr>
                <th scope="col">Area Code</th>
                <th scope="col">Location</th>
                <th scope="col">Current Time</th>
              </tr>
            </thead>
            <tbody>
              {filtered.map((areaCode) => (
                <AreaCodeRow areaCode={areaCode} key={areaCode.code} />
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <NoResults message="No area codes match that number." />
      )}
    </section>
  );
}
